import React, { Fragment, Children } from 'react';
import { Accordion, Table } from 'semantic-ui-react';

const LogMessageAccordionRow = React.forwardRef(
  function LogMessageAccordionRow(props, preRef) {
    const { children, active, error } = props;

    return (
      <Fragment>
        <Accordion.Title
          as={Table.Row}
          error={error}
        >
          {children}
        </Accordion.Title>
        <Accordion.Content
          active={active}
          as={Table.Row}
          className={'accordion-row'}
        >
          <Table.Cell colSpan={Children.count(children)}>
            <pre
              ref={preRef}
              className={'log-message'}
            />
          </Table.Cell>
        </Accordion.Content>
      </Fragment>
    );
  },
);

export default LogMessageAccordionRow;
